const mutations = {
  INIT_USER_STATE(state, {
    loginUrl,
    partnerUrl,
    redirectUrl,
    userId,
    userType,
    status,
    statusText,
    isPartner,
    avatarUrl,
    nick,
    profileUrl,
    increaseQuotaUrl,
    registerUrl,
    tarjetaCaducada,
    periodoGracia,
    carrito,
  }) {
    state.loginUrl = loginUrl;
    state.partnerUrl = partnerUrl;
    state.redirectUrl = redirectUrl;
    state.userId = userId;
    state.userType = userType;
    state.status = status;
    state.statusText = statusText;
    state.isPartner = isPartner;
    state.avatarUrl = avatarUrl;
    state.nick = nick;
    state.profileUrl = profileUrl;
    state.increaseQuotaUrl = increaseQuotaUrl;
    state.registerUrl = registerUrl;
    state.tarjetaCaducada = tarjetaCaducada;
    state.periodoGracia = periodoGracia;
    state.carrito = carrito;
  },
  INIT_VALUATIONS(state, valuations) {
    state.valuations = valuations;
  },
  VALUATE(state) {
    state.valuations = state.valuations + 1;
  },
  UNDO_VALUATION(state) {
    // El total de valoraciones de un contenido viene en las propiedades de la página de caída
    // del contenido, con lo cual está cacheado, esto significa que: si un contenido tiene
    // 0 likes, le das like, el contador sube a 1 y recargas la página el contador vuelve a 0,
    // porque es el resultado que esta cacheado, con lo cual, en ese momento le vuelves a dar "like"
    // para el navegador y este js, ese contenido ya está likeado (aunque ponga 0 por el cache)
    // por lo que deshace la valoración y el contador baja a -1. Esto es un trapi para evitar eso
    // Probablemente haya que guardar el resultado en el localStorage o hacer algún trapi.
    if (state.valuations) {
      state.valuations = state.valuations - 1;
    }
  }
};

export default mutations;
